var map = {
	".": "tksP",
	"./": "tksP",
	"./01_post_trade_aorder": "MZay",
	"./01_post_trade_aorder.json": "MZay",
	"./01_post_trade_batchOrders": "jKsK",
	"./01_post_trade_batchOrders.json": "jKsK",
	"./021_post_trade_order_cancel": "l/8P",
	"./021_post_trade_order_cancel.json": "l/8P",
	"./022_post_trade_orders_cancel": "uDFu",
	"./022_post_trade_orders_cancel.json": "uDFu",
	"./023_post_cancelOpenOrders": "BdSn",
	"./023_post_cancelOpenOrders.json": "BdSn",
	"./023_post_trade_order_cancel_replace": "qru4",
	"./023_post_trade_order_cancel_replace.json": "qru4",
	"./03_get_trade_order": "/YEw",
	"./03_get_trade_order.json": "/YEw",
	"./04_get_trade_open_order": "bfDi",
	"./04_get_trade_open_order.json": "bfDi",
	"./05_get_trade_history_order": "dcc+",
	"./05_get_trade_history_order.json": "dcc+",
	"./077_get_trade_fill_details": "ui1J",
	"./077_get_trade_fill_details.json": "ui1J",
	"./08_get_commissionRate": "OkZ/",
	"./08_get_commissionRate.json": "OkZ/",
	"./09_cancel_all_after": "IW4y",
	"./09_cancel_all_after.json": "IW4y",
	"./100_post_one_oco_order": "0DXm",
	"./100_post_one_oco_order.json": "0DXm",
	"./101_cancel_one_oco_order": "cfpy",
	"./101_cancel_one_oco_order.json": "cfpy",
	"./102_get_one_oco_order": "bM6w",
	"./102_get_one_oco_order.json": "bM6w",
	"./103_get_all_pending_oco_order": "EsEh",
	"./103_get_all_pending_oco_order.json": "EsEh",
	"./104_get_all_history_oco_order": "bjJG",
	"./104_get_all_history_oco_order.json": "bjJG",
	"./index": "tksP",
	"./index.js": "tksP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m/B5";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/trade ^.*$
// module id = m/B5
// module chunks = 3